import { lazy } from "react";
import Loadable from "components/Loadable";

const PageSectionList = Loadable(
  lazy(() => import("features/pageSection/components/List"))
);
const PageSectionForm = Loadable(
  lazy(() => import("features/pageSection/components/Page"))
);

const routes = {
  path: "pageSection",
  children: [
    { path: "", element: <PageSectionList /> },
    { path: "add", element: <PageSectionForm /> },
    { path: "edit/:sectionID?", element: <PageSectionForm /> },
  ],
};

export default routes;
